/*
 * Chatul Mia pe balkanprohealth.ro (20 oct. 2026).
 *
 * E `chat.js` din mu-plugin-ul balkan.ro (`wp-content/mu-plugins/balkan-ai-chat/`),
 * adaptat la Shopify. Conversatia, ritmul, bula proactiva, formularul de preluare si
 * masuratorile sunt NESCHIMBATE — vorbesc cu acelasi server, bot.balkan.ro.
 * Ce s-a schimbat, si de ce:
 *  - Serverul cunoaste catalogul WooCommerce: trimite ID-uri si linkuri de pe balkan.ro.
 *    Cardurile se refac din magazinul Shopify (`/products/<handle>.js`), prin harta din
 *    `sections/balkan-mia-harta.liquid` — altfel chatul ar trimite cumparatorul inapoi
 *    pe magazinul vechi. Pretul si stocul de pe card sunt cele de AICI, nu din Woo.
 *    Un produs care nu exista pe Shopify nu primeste card.
 *  - „Adauga in cos" merge la `/cart/add.js` si anunta tema Horizon prin
 *    `CartLinesUpdateEvent` (exact ca formularul de produs), deci bulina si sertarul
 *    se actualizeaza fara reincarcare. Apoi apare „Vezi cosul".
 *  - ID-ul conversatiei intra pe comanda ca atribut de cos (`_mia_sesiune`), in locul
 *    cookie-ului pe care il citea WooCommerce.
 *  - Porneste dupa `load`, cand browserul e liber, si isi incarca singur CSS-ul:
 *    nu concureaza cu prima afisare a paginii.
 *
 * ⚠️ Se incarca drept MODUL (`type="module"`), cu import static. CDN-ul Shopify minifica
 * asset-urile JS, iar intr-un script clasic a transformat `import('@shopify/events')` in
 * `require("@shopify/events")` — care nu exista in browser, deci produsul intra in cos, dar
 * bulina si sertarul ramaneau pe „gol" (masurat 20 oct. 2026). Intr-un modul importul ramane.
 */
import { CartLinesUpdateEvent } from '@shopify/events';

(function () {
    'use strict';

    if (window.__balkanMia) return;
    window.__balkanMia = true;

    var CFG = window.BalkanAI || {};
    var T = CFG.i18n || {};
    var API = CFG.api || '';
    if (!API) return;
    var root = null;

    var STORE_KEY = 'balkan_ai_session';

    /*
     * Ritmul conversatiei. Un chat care raspunde instantaneu la fiecare Enter se simte
     * ca un robot si deruleaza textul inainte ca omul sa apuce sa citeasca. Cele trei
     * valori de mai jos se pot schimba din panou (vin prin /api/config):
     *
     *   group  - cat asteptam dupa ultimul Enter inainte sa trimitem. Daca clientul isi
     *            imparte fraza pe mai multe randuri, ele ajung la agent ca UN mesaj.
     *   wait   - pauza minima inainte sa apara primul cuvant al raspunsului.
     *   speed  - cate caractere pe secunda "scrie" agentul.
     */
    var PACE = {
        group: 2000,      // cat asteptam dupa ultimul Enter
        wait: 2000,       // pauza minima inainte de primul cuvant al raspunsului
        speed: 55,        // caractere pe secunda la scriere
        typing: 3000,     // cat timp dupa ultima tasta consideram ca omul inca scrie
        maxHold: 20000    // plafon: chiar daca scrie intruna, nu amanam la nesfarsit
    };

    var state = {
        sessionId: null,
        open: false,
        busy: false,
        started: false,
        config: null,
        pending: [],        // randurile scrise de client care asteapta sa fie trimise impreuna
        groupTimer: null,
        lastTyping: 0,      // cand a apasat ultima tasta
        holdingSince: 0     // de cand tot amanam trimiterea
    };

    /* Sesiunea tine cat tine fila: conversatia se pastreaza la navigare, nu pentru totdeauna. */
    try { state.sessionId = sessionStorage.getItem(STORE_KEY) || null; } catch (e) {}

    var el = {};

    function icon(name) {
        var paths = {
            chat: '<path d="M12 3c-4.97 0-9 3.36-9 7.5 0 2.3 1.25 4.36 3.2 5.73L6 21l3.9-2.1c.67.13 1.38.2 2.1.2 4.97 0 9-3.36 9-7.5S16.97 3 12 3z"/>',
            close: '<path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round"/>',
            refresh: '<path d="M21 12a9 9 0 11-3-6.7M21 4v5h-5" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/>',
            send: '<path d="M3 20l18-8L3 4l4 8-4 8z"/>'
        };
        return '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">' + paths[name] + '</svg>';
    }

    function esc(s) {
        return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
            return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
        });
    }

    /* Formatare minima: **ingrosat**, tabele simple si paragrafe. Fara HTML din raspuns. */
    function format(text) {
        var safe = esc(text);
        var lines = safe.split('\n');
        var out = [];
        var table = null;

        function flushTable() {
            if (!table) return;
            var rows = table.filter(function (r) { return !/^\s*\|?[\s:|-]+\|?\s*$/.test(r); });
            var html = '<table>';
            rows.forEach(function (row, i) {
                var cells = row.replace(/^\||\|$/g, '').split('|');
                html += '<tr>' + cells.map(function (c) {
                    var tag = i === 0 ? 'th' : 'td';
                    return '<' + tag + '>' + c.trim() + '</' + tag + '>';
                }).join('') + '</tr>';
            });
            out.push(html + '</table>');
            table = null;
        }

        lines.forEach(function (line) {
            if (line.indexOf('|') >= 0 && line.trim().length > 2) {
                table = table || [];
                table.push(line);
                return;
            }
            flushTable();
            out.push(line);
        });
        flushTable();

        return out.join('\n')
            .replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
            .replace(/\n{3,}/g, '\n\n');
    }

    /* ---------- Constructia interfetei ---------- */

    function build() {
        root = document.getElementById('balkan-ai-root');
        if (!root) {
            root = document.createElement('div');
            root.id = 'balkan-ai-root';
            /* La finalul lui <body>, DUPA `.page-wrapper`: CSS-ul ascunde butonul cat e
               deschis sertarul de cos (`.page-wrapper--drawer-open ~ .bai-root`). */
            document.body.appendChild(root);
        }
        root.className = 'bai-root';
        /* Pe pagina de produs butonul urca deasupra barei lipite „Adauga in cos". */
        root.setAttribute('data-bai-pagina', CFG.pageType || 'other');
        root.innerHTML =
            '<button class="bai-launcher" type="button" aria-label="' + esc(T.open) + '">' +
                icon('chat') + '<span>' + esc(T.open) + '</span>' +
            '</button>' +
            '<div class="bai-panel" role="dialog" aria-label="' + esc(T.title) + '">' +
                '<div class="bai-header">' +
                    '<div class="bai-avatar">' + icon('chat') + '</div>' +
                    '<div><div class="bai-title">' + esc(T.title) + '</div>' +
                    '<div class="bai-subtitle">' + esc(T.subtitle) + '</div></div>' +
                    '<div class="bai-header-actions">' +
                        '<button class="bai-iconbtn bai-restart" type="button" title="' + esc(T.restart) + '" aria-label="' + esc(T.restart) + '">' + icon('refresh') + '</button>' +
                        '<button class="bai-iconbtn bai-close" type="button" title="' + esc(T.close) + '" aria-label="' + esc(T.close) + '">' + icon('close') + '</button>' +
                    '</div>' +
                '</div>' +
                '<div class="bai-messages"></div>' +
                '<div class="bai-composer">' +
                    '<div class="bai-inputrow">' +
                        '<textarea class="bai-input" rows="1" placeholder="' + esc(T.placeholder) + '" aria-label="' + esc(T.placeholder) + '"></textarea>' +
                        '<button class="bai-send" type="button" title="' + esc(T.send) + '" aria-label="' + esc(T.send) + '">' + icon('send') + '</button>' +
                    '</div>' +
                    '<p class="bai-disclaimer">' + esc(T.disclaimer) + '</p>' +
                '</div>' +
            '</div>';

        el.launcher = root.querySelector('.bai-launcher');
        el.panel    = root.querySelector('.bai-panel');
        el.messages = root.querySelector('.bai-messages');
        el.input    = root.querySelector('.bai-input');
        el.send     = root.querySelector('.bai-send');

        el.launcher.addEventListener('click', open);
        root.querySelector('.bai-close').addEventListener('click', close);
        root.querySelector('.bai-restart').addEventListener('click', restart);
        el.send.addEventListener('click', submit);

        el.input.addEventListener('keydown', function (e) {
            var isEnter = (e.key === 'Enter' || e.key === 'Return' || e.keyCode === 13);
            if (isEnter && !e.shiftKey) { e.preventDefault(); submit(); }
        });
        el.input.addEventListener('focus', function () {
            /* iOS deschide tastatura cu o mica intarziere; masuram dupa ce s-a asezat. */
            setTimeout(function () { fitViewport(); scroll(true); }, 300);
        });
        el.input.addEventListener('blur', function () {
            setTimeout(fitViewport, 300);
        });
        el.input.addEventListener('input', function () {
            el.input.style.height = 'auto';
            el.input.style.height = Math.min(110, el.input.scrollHeight) + 'px';

            /* Scrie chiar acum. Daca are deja randuri trimise care asteapta sa plece,
               amanam plecarea: omul isi continua gandul, nu vrem sa-l intrerupem. */
            state.lastTyping = Date.now();
            if (state.pending.length) scheduleSend();
        });
        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && state.open) close();
        });
    }

    function open() {
        state.open = true;
        nudgeHide();
        el.panel.classList.add('bai-open');
        el.launcher.classList.add('bai-hidden');
        document.body.classList.add('bai-chat-open');
        fitViewport();
        if (!state.started) {
            state.started = true;
            /* Daca discutia a inceput pe alta pagina, o readucem: agentul isi aminteste
               contextul, deci e corect ca si clientul sa-l vada. */
            if (state.sessionId) restore(); else greet();
        }
        setTimeout(function () { el.input.focus(); }, 60);
        track('opened');
    }

    function restore() {
        fetch(API + '/history.php?session_id=' + encodeURIComponent(state.sessionId))
            .then(function (r) { return r.json(); })
            .then(function (d) {
                if (!d || !d.messages || !d.messages.length) { greet(); return; }
                d.messages.forEach(function (m) {
                    if (m.role === 'user') { addUser(m.message); return; }
                    var bot = addBot();
                    bot.set(m.message);
                    if (m.products && m.products.length) renderProducts(bot.node, m.products);
                });
                scroll();
            })
            .catch(function () { greet(); });
    }

    /*
     * Potrivirea pe inaltimea reala a ecranului.
     *
     * Pe iOS, cand se deschide tastatura, pagina ramane la fel de inalta — se micsoreaza
     * doar zona vizibila (visualViewport). Un panou „fixed" ancorat jos ajunge astfel sub
     * tastatura, cu butonul de trimitere in afara ecranului. Aici masuram cat a ramas
     * vizibil si potrivim panoul peste exact acea zona.
     */
    function fitViewport() {
        var vv = window.visualViewport;
        if (!vv || !el.panel) return;

        if (window.innerWidth > 600) {           // pe desktop panoul e mic, nu-l atingem
            el.panel.classList.remove('bai-viewport');
            el.panel.style.transform = '';
            return;
        }
        root.style.setProperty('--bai-vh', Math.round(vv.height) + 'px');
        el.panel.classList.add('bai-viewport');
        /* Cand tastatura impinge zona vizibila in jos, mutam panoul cu ea. */
        el.panel.style.transform = 'translateY(' + Math.max(0, Math.round(vv.offsetTop)) + 'px)';
    }

    if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', fitViewport);
        window.visualViewport.addEventListener('scroll', fitViewport);
    }
    window.addEventListener('orientationchange', function () { setTimeout(fitViewport, 250); });

    function close() {
        state.open = false;
        el.panel.classList.remove('bai-open');
        el.launcher.classList.remove('bai-hidden');
        document.body.classList.remove('bai-chat-open');
        track('closed');
    }

    function restart() {
        state.sessionId = null;
        state.started = false;
        try { sessionStorage.removeItem(STORE_KEY); } catch (e) {}
        el.messages.innerHTML = '';
        greet();
    }

    /* ---------- Mesaje ---------- */

    function addUser(text) {
        var d = document.createElement('div');
        d.className = 'bai-msg bai-user';
        d.innerHTML = '<div class="bai-bubble">' + esc(text) + '</div>';
        el.messages.appendChild(d);
        scroll();
    }

    /*
     * Bula agentului. Textul nu se pune dintr-o data: intra intr-o coada si se scrie
     * treptat, cu viteza din PACE.speed, dupa o pauza minima (PACE.wait). Asa clientul
     * apuca sa citeasca, iar conversatia seamana cu una reala.
     */
    function addBot() {
        var d = document.createElement('div');
        d.className = 'bai-msg bai-bot';
        d.innerHTML = '<div class="bai-bubble"><div class="bai-typing"><span></span><span></span><span></span></div></div>';
        el.messages.appendChild(d);
        scroll();

        return {
            node: d,
            bubble: d.querySelector('.bai-bubble'),
            text: '',            // tot ce a trimis agentul
            shown: '',           // ce a apucat sa apara pe ecran
            queue: '',           // ce asteapta sa fie scris
            startedAt: Date.now(),
            timer: null,
            onDrain: [],         // tot ce asteapta finalul scrierii (carduri, deblocarea butonului)

            /* text nou de la agent */
            feed: function (chunk) {
                if (!chunk) return;
                this.text += chunk;
                this.queue += chunk;
                this.play();
            },

            /* afisare imediata - pentru ce nu vine de la model (istoric, erori) */
            set: function (value) {
                this.stop();
                this.text = this.shown = value;
                this.queue = '';
                this.bubble.innerHTML = format(value);
                scroll();
            },

            play: function () {
                var self = this;
                if (self.timer) return;
                self.timer = setInterval(function () {
                    /* pauza de politete inainte de primul cuvant */
                    if (self.shown === '' && Date.now() - self.startedAt < PACE.wait) return;

                    if (!self.queue.length) {
                        self.stop();
                        self.drain();
                        return;
                    }
                    /*
                     * Viteza de baza e cea din setari — buna pentru raspunsuri scurte,
                     * unde tocmai lentoarea da timp de citit. La raspunsuri lungi insa
                     * ar tine clientul zeci de secunde, asa ca accelereaza proportional:
                     * tinta e ca un raspuns intreg sa se scrie in cel mult ~12 secunde.
                     */
                    var viteza = Math.max(PACE.speed, self.text.length / 12, self.queue.length / 6);
                    var pas    = Math.max(1, Math.round(viteza * 0.06));
                    self.shown += self.queue.slice(0, pas);
                    self.queue = self.queue.slice(pas);
                    self.bubble.innerHTML = format(self.shown);
                    scroll();
                }, 60);
            },

            stop: function () {
                if (this.timer) { clearInterval(this.timer); this.timer = null; }
            },

            /*
             * Cheama cb dupa ce s-a terminat de scris tot ce a venit. Pot fi mai multe
             * astfel de cereri (cardurile de produs si deblocarea butonului de trimis),
             * deci le tinem intr-o lista — un singur loc le-ar face sa se suprascrie.
             */
            whenDone: function (cb) {
                this.onDrain.push(cb);
                if (!this.queue.length && !this.timer) { this.drain(); return; }
                this.play();
            },

            drain: function () {
                var lista = this.onDrain;
                this.onDrain = [];
                lista.forEach(function (cb) { cb(); });
            }
        };
    }

    /*
     * Derulare la zi - dar numai daca clientul se uita deja la ultimele mesaje.
     * Daca a derulat in sus ca sa reciteasca ceva, nu-l tragem inapoi.
     */
    function scroll(force) {
        var m = el.messages;
        var aproapeDeJos = (m.scrollHeight - m.scrollTop - m.clientHeight) < 80;
        if (force || aproapeDeJos) m.scrollTop = m.scrollHeight;
    }

    function greet() {
        state.started = true;
        var cfg = state.config || {};
        var bot = addBot();

        /* Pe clientii autentificati ii salutam pe nume — e magazinul lor, nu un ghiseu. */
        var salut = cfg.welcome || T.title;
        if (CFG.userName) {
            salut = (CFG.lang === 'en' ? 'Hi, ' : 'Salut, ') + CFG.userName + '! ' +
                    salut.replace(/^(Bună!|Buna!|Salut!|Hi!|Hello!|Hi,|Hello,)\s*/i, '');
        }
        bot.set(salut);

        var starters = (cfg.starters || []).slice(0, 5);
        if (CFG.productName) {
            /* Pe produs: intrebarile reale ale clientilor, din panou; agentul stie deja pe ce pagina e. */
            var aleProdusului = (cfg.starters_product || []).slice(0, 5);
            var scurt = CFG.productName.split(',')[0];
            starters = aleProdusului.length ? aleProdusului : (CFG.lang === 'en'
                ? ['How do I take ' + scurt + '?', 'What does this product contain?', 'Who is it suitable for?']
                : ['Cum se administrează ' + scurt + '?', 'Ce conține acest produs?', 'Pentru ce este potrivit?']
            ).concat(starters.slice(0, 2));
        }
        if (!starters.length) return;

        var wrap = document.createElement('div');
        wrap.className = 'bai-starters';
        starters.forEach(function (s) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'bai-starter';
            b.textContent = s;
            b.addEventListener('click', function () {
                wrap.remove();
                track('starter_click');
                ask(s);
            });
            wrap.appendChild(b);
        });
        bot.node.appendChild(wrap);
        scroll();
    }

    /*
     * Enter nu trimite imediat. Randul scris se vede pe loc in conversatie, dar plecarea
     * catre agent asteapta PACE.group milisecunde; daca intre timp clientul mai scrie un
     * rand, ele pleaca impreuna, ca un singur mesaj. Asa nu mai primeste cate un raspuns
     * pentru fiecare bucata de fraza.
     */
    function submit() {
        var text = el.input.value.trim();
        if (!text) return;
        el.input.value = '';
        el.input.style.height = 'auto';
        addUser(text);
        state.pending.push(text);
        scheduleSend();
    }

    function scheduleSend() {
        clearTimeout(state.groupTimer);
        state.groupTimer = setTimeout(flushPending, PACE.group);
    }

    function flushPending() {
        if (!state.pending.length) return;
        if (state.busy) { scheduleSend(); return; }   // agentul inca raspunde; mai asteptam

        /*
         * Daca omul e in mijlocul unui rand nou, il lasam sa-l termine. Conditia e dubla,
         * ca sa nu blocam trimiterea degeaba: are text neterminat in casuta SI a atins o
         * tasta de curand. Plafonul maxHold face ca cineva care scrie continuu sa nu ramana
         * totusi fara raspuns.
         */
        var scrieAcum = el.input.value.trim() !== '' &&
                        (Date.now() - state.lastTyping) < PACE.typing;
        if (!state.holdingSince) state.holdingSince = Date.now();

        if (scrieAcum && (Date.now() - state.holdingSince) < PACE.maxHold) {
            scheduleSend();
            return;
        }

        state.holdingSince = 0;
        var text = state.pending.join('\n');
        state.pending = [];
        ask(text, true);
    }

    /* ---------- Dialogul cu agentul ---------- */

    function ask(text, dejaAfisat) {
        if (state.busy) return;
        state.busy = true;
        el.send.disabled = true;
        if (!dejaAfisat) addUser(text);
        var bot = addBot();

        var payload = {
            message: text,
            stream: true,
            session_id: state.sessionId,
            lang: CFG.lang || 'ro',
            wp_user_id: CFG.userId || 0,
            user_name: CFG.userName || '',
            page_url: CFG.pageUrl || location.href,
            page_title: CFG.pageTitle || document.title,
            product_id: CFG.productId || 0
        };

        fetch(API + '/chat.php', {
            method: 'POST',
            headers: { 'content-type': 'application/json' },
            body: JSON.stringify(payload)
        }).then(function (res) {
            if (!res.ok || !res.body) return fallbackJson(payload, bot, res);
            return readStream(res, bot);
        }).catch(function () {
            bot.set(T.error);
        }).then(function () {
            /* Butonul se deblocheaza abia dupa ce s-a terminat de scris raspunsul. */
            bot.whenDone(function () {
                state.busy = false;
                el.send.disabled = false;
                if (state.pending.length) scheduleSend();   // a mai scris ceva intre timp
            });
        });
    }

    /* Fluxul SSE: fiecare „delta" e o bucata de text, „done" aduce raspunsul complet. */
    function readStream(res, bot) {
        var reader = res.body.getReader();
        var decoder = new TextDecoder();
        var buffer = '';
        var first = true;

        function handleEvent(raw) {
            var lines = raw.split('\n');
            var type = 'message';
            var data = '';
            lines.forEach(function (l) {
                if (l.indexOf('event:') === 0) type = l.slice(6).trim();
                else if (l.indexOf('data:') === 0) data += l.slice(5).trim();
            });
            if (!data) return;
            var payload;
            try { payload = JSON.parse(data); } catch (e) { return; }

            if (type === 'session') {
                setSession(payload.session_id);
            } else if (type === 'delta') {
                if (first) { bot.bubble.innerHTML = ''; first = false; }
                bot.feed(payload.text || '');
            } else if (type === 'done') {
                finish(bot, payload);
            }
        }

        function pump() {
            return reader.read().then(function (r) {
                if (r.done) return;
                buffer += decoder.decode(r.value, { stream: true });
                var parts = buffer.split('\n\n');
                buffer = parts.pop();
                parts.forEach(handleEvent);
                return pump();
            });
        }
        return pump();
    }

    /* Daca serverul nu poate tine flux (proxy care tamponeaza), cerem raspunsul intr-o bucata. */
    function fallbackJson(payload, bot, res) {
        if (res && res.status === 429) {
            return res.json().then(function (d) { bot.set(d.message || T.error); });
        }
        payload.stream = false;
        return fetch(API + '/chat.php', {
            method: 'POST',
            headers: { 'content-type': 'application/json' },
            body: JSON.stringify(payload)
        }).then(function (r) { return r.json(); }).then(function (d) {
            if (d.session_id) setSession(d.session_id);
            bot.set(d.message || T.error);
            finish(bot, d, true);
        });
    }

    function setSession(id) {
        if (!id) return;
        state.sessionId = id;
        try { sessionStorage.setItem(STORE_KEY, id); } catch (e) {}
        marcheazaCosul(id);
    }

    /*
     * Pe balkan.ro, cookie-ul `balkan_ai_sid` era pus de magazin pe comanda, ca sa se vada
     * daca discutia a dus la o vanzare. Shopify nu citeste cookie-uri straine, dar duce pe
     * comanda atributele cosului. `_` in fata = nu se arata cumparatorului la finalizare;
     * se vede in admin si prin API. O singura cerere pe conversatie.
     */
    function marcheazaCosul(id) {
        try { if (sessionStorage.getItem('balkan_ai_cos') === id) return; } catch (e) {}
        fetch('/cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ attributes: { _mia_sesiune: id } })
        }).then(function (r) {
            if (r.ok) try { sessionStorage.setItem('balkan_ai_cos', id); } catch (e) {}
        }).catch(function () {});
    }

    /*
     * Cat a ramas de scris din textul final, stiind ce s-a afisat deja.
     * Comparam doar caracterele vizibile, ca diferentele de spatii si randuri goale
     * sa nu ne faca sa rescriem tot mesajul. Intoarce null daca textul e cu totul altul.
     */
    function restulDupa(final, primit) {
        var vazut = (primit || '').replace(/\s/g, '');
        if (!vazut) return final;
        var n = 0, i = 0;
        for (; i < final.length && n < vazut.length; i++) {
            if (/\s/.test(final[i])) continue;
            if (final[i] !== vazut[n]) return null;
            n++;
        }
        return n === vazut.length ? final.slice(i) : null;
    }

    /*
     * Cardurile si butoanele apar abia dupa ce textul s-a terminat de scris - altfel ar
     * sari in fata raspunsului si l-ar impinge pe client in jos inainte sa fi citit.
     */
    function finish(bot, data, skipText) {
        if (data.session_id) setSession(data.session_id);

        if (!skipText && data.message && data.message !== bot.text) {
            /*
             * Textul final poate diferi de suma bucatilor primite prin flux: intre rundele
             * agentului se adauga un rand gol, iar verificarea de siguranta poate inlocui
             * raspunsul. Daca e doar continuarea a ceea ce s-a scris deja, o scriem mai
             * departe in acelasi ritm; daca e cu totul alt text, il punem dintr-o data.
             */
            var rest = restulDupa(data.message, bot.text);
            if (rest === null) bot.set(data.message);
            else if (rest !== '') bot.feed(rest);
        }

        bot.whenDone(function () {
            if (data.products && data.products.length) renderProducts(bot.node, data.products);
            if (data.actions && data.actions.length) renderActions(bot.node, data.actions);
            if (data.message_id) renderFeedback(bot.node, data.message_id);
            scroll();
        });
    }

    /* ---------- Produsele: din catalogul Woo al serverului, in magazinul Shopify ---------- */

    /*
     * Harta vine o singura data pe pagina, si doar cand Mia chiar recomanda ceva.
     * Randurile: [google_id, google_grup, handle, id varianta, nr. variante, primar].
     * `google_id` = articolul exact din Woo (produs simplu sau variatie) → varianta exacta.
     * `google_grup` = produsul-parinte → pagina produsului; la izolatul despartit in 8
     * produse castiga aroma principala (`primar`).
     */
    var harta = null;
    function incarcaHarta() {
        if (harta) return harta;
        harta = fetch('/?section_id=balkan-mia-harta', { credentials: 'same-origin' })
            .then(function (r) { return r.ok ? r.text() : ''; })
            .then(function (html) {
                var m = /<script[^>]*data-bai-harta[^>]*>([\s\S]*?)<\/script>/.exec(html);
                var randuri = m ? JSON.parse(m[1]) : [];
                var map = {};
                randuri.forEach(function (r) {
                    map['i' + r[0]] = { h: r[2], v: r[3], n: r[4] };
                    var g = map['g' + r[1]];
                    if (!g || (r[5] && !g.p)) map['g' + r[1]] = { h: r[2], v: null, n: r[4], p: r[5] };
                });
                return map;
            })
            .catch(function () { return {}; });
        return harta;
    }

    function produsShopify(handle) {
        return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
            .then(function (r) { return r.ok ? r.json() : null; })
            .catch(function () { return null; });
    }

    function imagineMica(src) {
        if (!src) return '';
        if (src.indexOf('//') === 0) src = 'https:' + src;
        return src + (src.indexOf('?') >= 0 ? '&' : '?') + 'width=160';
    }

    /*
     * Cardul primit de la server → cardul magazinului de aici, sau null.
     * Ordinea de cautare: articolul exact, apoi produsul-parinte, apoi slug-ul din link
     * (catalogul a fost importat cu slug-urile Woo, deci la majoritatea coincid).
     * Un produs care nu exista aici nu primeste card: mai bine lipsa decat un link
     * catre balkan.ro sau catre alt produs.
     */
    function potriveste(p, map) {
        var id = String(p.product_id || '');
        var gasit = map['i' + id] || map['g' + id] || null;
        var handle = gasit ? gasit.h : '';
        if (!handle && p.url) {
            var m = /\/([^\/?#]+)\/?(?:[?#].*)?$/.exec(p.url);
            if (m) handle = decodeURIComponent(m[1]);
        }
        if (!handle) return Promise.resolve(null);

        return produsShopify(handle).then(function (prod) {
            if (!prod) return null;
            var variante = prod.variants || [];
            var exacta = null;
            if (gasit && gasit.v) {
                exacta = variante.filter(function (v) { return v.id === gasit.v; })[0] || null;
            } else if (variante.length === 1 && p.type !== 'variable') {
                exacta = variante[0];
            }
            var pret = exacta ? exacta.price : prod.price;
            var tiat = exacta ? exacta.compare_at_price : prod.compare_at_price;
            return {
                product_id: p.product_id,                 // ID-ul Woo: masuratorile serverului il asteapta
                name: prod.title,
                price: pret / 100,
                regular_price: tiat && tiat > pret ? tiat / 100 : null,
                on_sale: !!(tiat && tiat > pret),
                image: imagineMica(prod.featured_image),
                url: prod.url,
                in_stock: exacta ? exacta.available : prod.available,
                /* Aroma sau marimea se alege pe pagina produsului, ca pe balkan.ro. */
                type: exacta ? 'simple' : 'variable',
                variant: exacta ? exacta.id : null
            };
        });
    }

    function renderProducts(node, products) {
        var wrap = document.createElement('div');
        wrap.className = 'bai-products';
        node.appendChild(wrap);
        incarcaHarta().then(function (map) {
            return Promise.all(products.map(function (p) {
                return potriveste(p, map).catch(function () { return null; });
            }));
        }).then(function (carduri) {
            carduri.forEach(function (c) { if (c) wrap.appendChild(productCard(c)); });
            if (!wrap.children.length) wrap.remove();
            scroll();
        });
    }

    function productCard(p) {
        var card = document.createElement('div');
        card.className = 'bai-card';

        var price = p.price != null ? formatPrice(p.price) : '';
        if (p.on_sale && p.regular_price) price += '<del>' + formatPrice(p.regular_price) + '</del>';

        card.innerHTML =
            (p.image ? '<img class="bai-card-img" src="' + esc(p.image) + '" alt="" loading="lazy" width="74" height="74">' : '<div class="bai-card-img"></div>') +
            '<div class="bai-card-body">' +
                '<div class="bai-card-name">' + esc(p.name) + '</div>' +
                '<div class="bai-card-price">' + price + '</div>' +
                '<div class="bai-card-stock' + (p.in_stock ? '' : ' bai-out') + '">' +
                    (p.in_stock ? 'În stoc' : esc(T.outofstock)) + '</div>' +
                '<div class="bai-card-actions"></div>' +
            '</div>';

        var actions = card.querySelector('.bai-card-actions');

        var view = document.createElement('a');
        view.className = 'bai-btn';
        view.href = p.url;
        view.textContent = T.view;
        view.addEventListener('click', function () {
            track('product_click', p.product_id, p.price);
        });
        actions.appendChild(view);

        /* Produsele cu variante (arome, gramaje) se aleg pe pagina lor — nu ghicim noi varianta. */
        var canAdd = (state.config ? state.config.add_to_cart : true) && p.in_stock && p.type !== 'variable' && p.variant;
        if (canAdd) {
            var add = document.createElement('button');
            add.type = 'button';
            add.className = 'bai-btn bai-primary';
            add.textContent = T.add;
            add.addEventListener('click', function () { addToCart(p, add); });
            actions.appendChild(add);
        } else if (p.type === 'variable' && p.in_stock) {
            view.classList.add('bai-primary');
            view.textContent = T.variants;
        }
        return card;
    }

    function formatPrice(v) {
        return Number(v).toLocaleString('ro-RO', { minimumFractionDigits: 0, maximumFractionDigits: 2 }) + ' lei';
    }

    /*
     * Adaugarea in cos.
     *
     * Folosim drumul formularului de produs al temei Horizon: `CartLinesUpdateEvent` din
     * `@shopify/events` (in importmap-ul temei), cu o promisiune rezolvata dupa raspunsul
     * de la `/cart/add.js`. Cererea cere si sectiunile `cart-items-component`, deci
     * sertarul se reface din raspuns, fara a doua cerere, iar bulina din header se
     * actualizeaza.
     *
     * Agentul nu plaseaza comenzi si nu atinge cosul — doar clientul, prin acest buton.
     */
    function adaugaInCos(p) {
        var sectiuni = [];
        document.querySelectorAll('cart-items-component').forEach(function (c) {
            if (c.dataset.sectionId && sectiuni.indexOf(c.dataset.sectionId) < 0) sectiuni.push(c.dataset.sectionId);
        });

        var Ev = CartLinesUpdateEvent;
        var amanat = Ev.createPromise();
        root.dispatchEvent(new Ev({
            action: 'add',
            context: 'product',
            lines: [{ merchandiseId: String(p.variant), quantity: 1 }],
            promise: amanat.promise
        }));
        var corp = { items: [{ id: p.variant, quantity: 1 }] };
        if (sectiuni.length) { corp.sections = sectiuni.join(','); corp.sections_url = location.pathname; }

        return fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(corp)
        }).then(function (r) {
            return r.json().then(function (d) {
                if (!r.ok || d.status) throw new Error(d.description || d.message || 'add failed');
                return d;
            });
        }).then(function (d) {
            return fetch('/cart.js', { credentials: 'same-origin' })
                .then(function (r) { return r.json(); })
                .then(function (cart) {
                    amanat.resolve({
                        cart: Ev.createCartFromAjaxResponse(cart),
                        detail: {
                            items: cart.items,
                            source: 'balkan-mia',
                            sourceId: 'balkan-mia',
                            itemCount: 1,
                            productId: String(p.variant),
                            sections: d.sections,
                            didError: false
                        }
                    });
                });
        }).catch(function (err) {
            amanat.reject(err);
            throw err;
        });
    }

    function addToCart(p, button) {
        button.disabled = true;
        var original = button.textContent;
        button.textContent = T.adding;

        adaugaInCos(p).then(function () {
            button.textContent = T.added;
            nudgeCancel();
            track('add_to_cart', p.product_id, p.price);
            /* Daca vizita a pornit din bula, cosul se pune in contul variantei ei (test A/B). */
            try {
                var dinBula = sessionStorage.getItem(NUDGE_KEY + '_click');
                if (dinBula) track('nudge_cart', p.product_id, p.price, dinBula);
            } catch (e) {}
            butonCos(button.parentNode);
        }).catch(function () {
            button.disabled = false;
            button.textContent = original;
            window.location.href = p.url;
        });
    }

    /*
     * Pe balkan.ro adaugarea deschidea popup-ul cosului. Aici sertarul s-ar deschide SUB
     * chat (pe telefon chatul ocupa tot ecranul), deci il lasam pe client sa aleaga:
     * „Vezi cosul" inchide chatul si deschide sertarul, prin butonul din header — singurul
     * API public al temei (acelasi drum ca `balkan-cart.js`).
     */
    function butonCos(actions) {
        if (!actions || actions.querySelector('.bai-tocart')) return;
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'bai-btn bai-tocart';
        b.textContent = T.cart || 'Vezi coșul';
        b.addEventListener('click', function () {
            close();
            var t = document.querySelector('[aria-controls="cart-drawer"]');
            if (t && t.getAttribute('aria-expanded') !== 'true') t.click();
            else if (!t) window.location.href = '/cart';
        });
        actions.appendChild(b);
    }

    function renderActions(node, actions) {
        actions.forEach(function (a) {
            if (a.type !== 'handoff') return;
            if (a.form) renderHandoffForm(node, a); else renderHandoffLink(node, a);
        });
    }

    function renderHandoffLink(node, a) {
        var wrap = document.createElement('div');
        wrap.className = 'bai-card-actions';
        wrap.style.marginTop = '8px';
        var link = document.createElement('a');
        link.className = 'bai-btn bai-primary';
        link.href = 'mailto:' + (a.email || 'contact@balkan.ro');
        link.textContent = a.label || 'Contact';
        wrap.appendChild(link);
        node.appendChild(wrap);
    }

    /*
     * Formularul de preluare: in loc sa-l trimitem pe client sa sune, ii cerem numele si
     * telefonul aici, iar echipa primeste un email si il suna ea. O singura data pe conversatie.
     */
    var HF = CFG.lang === 'en' ? {
        title: 'Leave your details and a colleague will call you back during business hours.',
        name: 'Your name', phone: 'Phone number', email: 'Email (optional)', msg: 'What is it about? (optional)',
        send: 'Send to the team', sending: 'Sending…', ok: 'Thank you! A colleague will contact you Monday to Friday, 9:00-17:00.',
        err: 'We need your name and a phone number or email.', fail: 'Could not send. Please call 0723 233 230 or write to contact@balkan.ro.',
        mail: 'or write to us'
    } : {
        title: 'Lasă-mi datele tale și un coleg te sună înapoi în program.',
        name: 'Numele tău', phone: 'Număr de telefon', email: 'Email (opțional)', msg: 'Despre ce e vorba? (opțional)',
        send: 'Trimite echipei', sending: 'Se trimite…', ok: 'Mulțumesc! Un coleg te contactează luni-vineri, 9:00-17:00.',
        err: 'Avem nevoie de nume și de un telefon sau email.', fail: 'Nu am putut trimite. Sună la 0723 233 230 sau scrie pe contact@balkan.ro.',
        mail: 'sau scrie-ne pe email'
    };

    function renderHandoffForm(node, a) {
        if (state.handoffSent) return;
        if (document.querySelector('.bai-hf')) return;      // un singur formular deschis
        var f = document.createElement('form');
        f.className = 'bai-hf';
        f.noValidate = true;
        f.innerHTML =
            '<div class="bai-hf-title">' + esc(HF.title) + '</div>' +
            '<input class="bai-hf-in" name="name" type="text" autocomplete="name" placeholder="' + esc(HF.name) + '" aria-label="' + esc(HF.name) + '" maxlength="80">' +
            '<input class="bai-hf-in" name="phone" type="tel" autocomplete="tel" inputmode="tel" placeholder="' + esc(HF.phone) + '" aria-label="' + esc(HF.phone) + '" maxlength="20">' +
            '<input class="bai-hf-in" name="email" type="email" autocomplete="email" placeholder="' + esc(HF.email) + '" aria-label="' + esc(HF.email) + '" maxlength="120">' +
            '<textarea class="bai-hf-in" name="message" rows="2" placeholder="' + esc(HF.msg) + '" aria-label="' + esc(HF.msg) + '" maxlength="1000"></textarea>' +
            '<div class="bai-hf-row"><button type="submit" class="bai-btn bai-primary">' + esc(HF.send) + '</button>' +
            '<a class="bai-hf-mail" href="mailto:' + esc(a.email || 'contact@balkan.ro') + '">' + esc(HF.mail) + '</a></div>' +
            '<div class="bai-hf-msg" aria-live="polite"></div>';
        if (CFG.userName) f.querySelector('[name=name]').value = CFG.userName;
        node.appendChild(f);
        scroll(true);

        f.addEventListener('submit', function (e) {
            e.preventDefault();
            var d = {
                session_id: state.sessionId || '',
                name: f.name.value.trim(), phone: f.phone.value.trim(),
                email: f.email.value.trim(), message: f.message.value.trim()
            };
            var m = f.querySelector('.bai-hf-msg');
            if (!d.name || (d.phone.replace(/\D/g, '').length < 9 && !d.email)) { m.textContent = HF.err; return; }
            var btn = f.querySelector('button'); btn.disabled = true; btn.textContent = HF.sending;
            fetch(API + '/handoff.php', { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify(d) })
                .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
                .then(function (res) {
                    if (res.ok && res.j && res.j.ok) {
                        state.handoffSent = true;
                        f.innerHTML = '<div class="bai-hf-ok">' + esc(HF.ok) + '</div>';
                    } else {
                        btn.disabled = false; btn.textContent = HF.send;
                        m.textContent = (res.j && res.j.message) || HF.fail;
                    }
                })
                .catch(function () { btn.disabled = false; btn.textContent = HF.send; m.textContent = HF.fail; });
        });
    }

    /* ---------- Feedback ---------- */

    function renderFeedback(node, messageId) {
        var box = document.createElement('div');
        box.className = 'bai-feedback';
        box.innerHTML = '<span>' + esc(T.helpful) + '</span>';

        [['1', '👍 ' + T.yes], ['-1', '👎 ' + T.no]].forEach(function (pair) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'bai-fb';
            b.textContent = pair[1];
            b.addEventListener('click', function () {
                Array.prototype.forEach.call(box.querySelectorAll('.bai-fb'), function (x) { x.disabled = true; });
                b.classList.add('bai-active');
                send('/feedback.php', { session_id: state.sessionId, message_id: messageId, vote: Number(pair[0]) });
                var thanks = document.createElement('span');
                thanks.textContent = T.thanks;
                box.appendChild(thanks);
            });
            box.appendChild(b);
        });
        node.appendChild(box);
    }

    /* ---------- Masuratori ---------- */

    function track(type, productId, value, meta) {
        var faraSesiune = (type === 'loaded' || type === 'opened' || type === 'closed' || type.indexOf('nudge_') === 0);
        if (!state.sessionId && !faraSesiune) return;
        send('/event.php', { session_id: state.sessionId || '', type: type, product_id: productId || 0, value: value, meta: meta || '' });
    }

    /* ---------- Bula proactiva ---------- */

    /*
     * Dupa un timp pe pagina fara nimic pus in cos, langa buton apare o bula mica, de parca
     * Mia ar fi scris prima. Nu deschidem fereastra de la sine: pe telefon ar acoperi pagina
     * exact cand omul citeste, iar Google trateaza asa ceva ca interstitial intruziv.
     *
     * Reguli: doar pe paginile alese din panou; dupa N secunde pe pagina SI dupa cateva
     * secunde de liniste (nu in timp ce deruleaza); o singura data pe vizita; dispare la
     * deschiderea chatului, la adaugarea in cos sau la x; nu apare daca fila e in fundal.
     */
    var NUDGE_KEY = 'balkan_ai_nudge';
    var nudge = { el: null, timer: null, lastActivity: Date.now(), cfg: null };

    function nudgeSetup(cfg) {
        if (!cfg || !cfg.enabled) return;
        if ((cfg.pages || []).indexOf(CFG.pageType || 'other') < 0) return;
        try { if (sessionStorage.getItem(NUDGE_KEY)) return; } catch (e) {}
        if (state.sessionId) return;                 // a vorbit deja cu Mia in vizita asta
        nudge.cfg = cfg;

        var marcheaza = function () { nudge.lastActivity = Date.now(); };
        ['scroll', 'mousemove', 'keydown', 'touchstart', 'click'].forEach(function (ev) {
            window.addEventListener(ev, marcheaza, { passive: true });
        });
        /* a pus ceva in cos -> si-a rezolvat singur treaba, nu-l mai batem la cap.
           Pe balkan.ro asculta `added_to_cart` din jQuery; aici, orice formular de
           adaugare al temei (pagina de produs, bara lipita, cardurile). */
        document.addEventListener('submit', function (e) {
            if (e.target && e.target.closest && e.target.closest('form[data-type="add-to-cart-form"]')) nudgeCancel();
        }, true);

        nudge.timer = setTimeout(nudgeTry, Math.max(5, cfg.delay || 40) * 1000);
    }

    function nudgeTry() {
        if (state.open || state.sessionId || !nudge.cfg) return;
        var idle = (typeof nudge.cfg.idle === 'number') ? nudge.cfg.idle : 4;   /* 0 = apare si in timp ce deruleaza */
        var liniste = idle <= 0 || (Date.now() - nudge.lastActivity) >= idle * 1000;
        if (document.hidden || !liniste) {           // mai asteptam putin si verificam iar
            nudge.timer = setTimeout(nudgeTry, 2000);
            return;
        }
        nudgeShow();
    }

    /* Varianta A/B a bulei: trasa la sorti o data per vizitator si tinuta in localStorage,
       ca acelasi om sa vada mereu acelasi text. Fara text B in panou, toti vad A. */
    function nudgeVariant() {
        if (!nudge.cfg || !nudge.cfg.text_product_b) return 'A';
        var v = '';
        try { v = localStorage.getItem(NUDGE_KEY + '_var') || ''; } catch (e) {}
        if (v !== 'A' && v !== 'B') {
            v = Math.random() < 0.5 ? 'A' : 'B';
            try { localStorage.setItem(NUDGE_KEY + '_var', v); } catch (e) {}
        }
        return v;
    }

    function nudgeText() {
        var c = nudge.cfg;
        if (CFG.pageType === 'product' && CFG.productName) {
            var scurt = CFG.productName.split(',')[0].trim();
            var v = nudgeVariant();
            var text = v === 'B' ? c.text_product_b : c.text_product;
            var ask  = v === 'B' ? (c.ask_product_b || c.ask_product) : c.ask_product;
            return { text: (text || '').replace('{produs}', scurt),
                     ask:  (ask  || '').replace('{produs}', scurt), variant: v };
        }
        return { text: c.text_category || '', ask: '', variant: 'C' };
    }

    function nudgeShow() {
        var t = nudgeText();
        if (!t.text) return;
        try { sessionStorage.setItem(NUDGE_KEY, '1'); } catch (e) {}   // o singura data pe vizita

        var b = document.createElement('div');
        b.className = 'bai-nudge';
        b.setAttribute('role', 'status');
        b.innerHTML =
            '<button type="button" class="bai-nudge-x" aria-label="' + esc(T.close) + '">&times;</button>' +
            '<div class="bai-nudge-name">' + esc(T.title) + '</div>' +
            '<div class="bai-nudge-text">' + esc(t.text) + '</div>';
        root.appendChild(b);
        nudge.el = b;
        requestAnimationFrame(function () { b.classList.add('bai-nudge-in'); });
        track('nudge_shown', CFG.productId || 0, null, t.variant);

        b.querySelector('.bai-nudge-x').addEventListener('click', function (e) {
            e.stopPropagation();
            track('nudge_dismiss', CFG.productId || 0, null, t.variant);
            nudgeHide();
        });
        b.addEventListener('click', function () {
            track('nudge_click', CFG.productId || 0, null, t.variant);
            try { sessionStorage.setItem(NUDGE_KEY + '_click', t.variant); } catch (e) {}
            nudgeHide();
            open();
            /* Pe produs, clickul inseamna „da, spune-mi" — trimitem intrebarea in locul lui. */
            if (t.ask) setTimeout(function () { if (!state.busy) ask(t.ask); }, 900);
        });
    }

    function nudgeHide() {
        if (nudge.timer) { clearTimeout(nudge.timer); nudge.timer = null; }
        if (!nudge.el) return;
        var b = nudge.el; nudge.el = null;
        b.classList.remove('bai-nudge-in');
        setTimeout(function () { b.remove(); }, 250);
    }

    function nudgeCancel() {
        try { sessionStorage.setItem(NUDGE_KEY, '1'); } catch (e) {}
        nudgeHide();
    }

    function send(path, body) {
        try {
            fetch(API + path, {
                method: 'POST',
                headers: { 'content-type': 'application/json' },
                body: JSON.stringify(body),
                keepalive: true
            }).catch(function () {});
        } catch (e) {}
    }

    /* ---------- Pornire ---------- */

    /* Foaia de stil se incarca odata cu configurarea, nu in <head>: nu blocheaza afisarea,
       iar butonul se construieste abia cand stilul a sosit (altfel ar clipi nestilizat). */
    function incarcaStil() {
        return new Promise(function (gata) {
            if (!CFG.css || document.querySelector('link[data-bai-css]')) { gata(); return; }
            var l = document.createElement('link');
            l.rel = 'stylesheet';
            l.href = CFG.css;
            l.setAttribute('data-bai-css', '');
            l.onload = l.onerror = function () { gata(); };
            document.head.appendChild(l);
        });
    }

    function porneste() {
        var config = fetch(API + '/config.php?lang=' + encodeURIComponent(CFG.lang || 'ro'), { method: 'GET' })
            .then(function (r) { return r.json(); });

        Promise.all([config, incarcaStil()])
            .then(function (rez) {
                var cfg = rez[0];
                if (!cfg || cfg.enabled === false) return;   // agentul e oprit din panou
                state.config = cfg;
                if (cfg.name) T.title = cfg.name;   // numele se schimba din panou, nu din cod
                if (cfg.pace) {
                    if (cfg.pace.group  >= 0) PACE.group  = cfg.pace.group;
                    if (cfg.pace.wait   >= 0) PACE.wait   = cfg.pace.wait;
                    if (cfg.pace.speed  >  0) PACE.speed  = cfg.pace.speed;
                    if (cfg.pace.typing >= 0) PACE.typing = cfg.pace.typing;
                }
                build();
                /* Numitorul palniei: cati vizitatori au avut butonul in fata (o data pe vizita). */
                try {
                    if (!sessionStorage.getItem('balkan_ai_loaded')) {
                        sessionStorage.setItem('balkan_ai_loaded', '1');
                        track('loaded', CFG.productId || 0);
                    }
                } catch (e) {}
                nudgeSetup(cfg.nudge);
            })
            .catch(function () { /* agentul nu raspunde: site-ul ramane exact cum era */ });
    }

    /* Dupa `load` si cand firul principal e liber: chatul nu are ce cauta in primele
       secunde, cand se masoara LCP-ul si blocarea paginii. */
    function candELiber() {
        if ('requestIdleCallback' in window) requestIdleCallback(porneste, { timeout: 3000 });
        else setTimeout(porneste, 1200);
    }
    if (document.readyState === 'complete') candELiber();
    else window.addEventListener('load', candELiber, { once: true });
})();
